export const emailMap: Record<string, { label: string; value: string }> = {
  flair: {
    label: "Flair",
    value: "operations.aircommittee@gmail.com",
  },
  scorch: {
    label: "Scorch",
    value: "info@thescorch.com",
  },
  elektra: {
    label: "Elektra",
    // value: "goweb13653@endibit.com",
    value: "elektratribe@gmail.com",
  },
  travisworld: {
    label: "Travis World",
    // value: "testopenregs@mailsac.com",
    value: "info@travisworldmusic.com",
  },
  epiccarnival: {
    label: "Epic Carnival",
    // value: "testopenregs@mailsac.com",
    value: "Marketing@myepiccarnival.com",
  },
  genx: {
    label: "GenX",
    // value: "openregstest@mailsac.com",
    value: "marketing@genxcarnival.com",
  },
  battalionmusic: {
    label: "Battalion Music (Private Ryan)",
    value: "battalioncostumes@gmail.com",
  },
  trinijunglejuice: {
    label: "Trini Jungle Juice",
    value: "carnival@trinijunglejuice.com",
  },
  islandcrashers: {
    label: "Island Crashers",
    value: "islandcrashers.tickets@gmail.com",
  },
  lil: {
    label: "LIL",
    value: "Rudolphtcharles@gmail.com",
  },
  solangegovia: {
    label: "Solange Govia",
    value: "solangegovia@gmail.com",
  },
  nataliefonrose: {
    label: "Natalie Fonrose",
    value: "natalie.fonrose@gmail.com",
  },
  daviddewer: {
    label: "David Dewer",
    value: "daviddewer@gmail.com",
  },
  tribeu: {
    label: "TRIBE U",
    value: "tribeutt@gmail.com",
  },
  clubhouse: {
    label: "Clubhouse",
    value: "Theclubhouse868@gmail.com",
  },
  midnight: {
    label: "Midnight",
    value: "midnighteventstt@gmail.com",
  },
  marieange: {
    label: "Marieange",
    value: "marieangebovell95@gmail.com",
  },
  livinlocal: {
    label: "Livin Local",
    value: "livinlocalent@gmail.com",
  },
  registerwithDwayne: {
    label: "Dwayne",
    value: "dnobrega@ultimategrouptt.com",
  },
  withdean: {
    label: "Dean Ackin",
    value: "deanreg2026@gmail.com",
  },
  withmonique: {
    label: "Monique Nobrega",
    value: "mnobrega@ultimategrouptt.com",
  },
  withgerard: {
    label: "Gerard Ramirez",
    value: "gramirez@ultimategrouptt.com",
  },
  withmelissa: {
    label: "Melissa James",
    value: "melissajames@ultimategrouptt.com",
  },
  withlana: {
    label: "Lana Nobrega",
    value: "lana-nobrega@hotmail.com",
  },
  withgail: {
    label: "Gail Cabral",
    value: "gailadamscabral@hotmail.com",
  },
  absolute: {
    label: "James Phillips",
    value: "jamesjayphillips@gmail.com",
  },
  energy: {
    label: "Angelo Aziz",
    value: "angeloaziz@gmail.com",
  },
  houseofbachannal: {
    label: "Khalil Mohammed",
    value: "iambachannal@gmail.com",
  },
  dlux: {
    label: "Tony Harrysingh",
    value: "dluxtt24@gmail.com",
  },
  punchypunch: {
    label: "Mark Deane",
    value: "markdeane@gmail.com",
  },
  laurana: {
    label: "Laura Narayansingh",
    value: "l.narayansingh@outlook.com",
  },
  chandramaharaj: {
    label: "Chandra Maharaj",
    value: "chandra@chandramaharajdesigns.com",
  },
  shawndhanraj: {
    label: "Shawn Maharaj",
    value: "shawndhanrajcarnival@gmail.com",
  },
  madjouvert: {
    label: "Kahlil Mathura",
    value: "kahlil.mathura@gmail.com",
  },
  bikinicabana: {
    label: "Vanessa Mohammed",
    value: "bikinicabanalts@gmail.com",
  },
  farmhouse: {
    label: "Jonathan Paty",
    value: "farmhousecooler@gmail.com",
  },
  jcamfitness: {
    label: "Jenna Camacho",
    value: "jcamfit@gmail.com",
  },
  iimagine: {
    label: "Serala Ramlogan",
    value: "serala.ramlogan@gmail.com",
  },
  krisp: {
    label: "Patrick Dougall",
    value: "pdougall17@gmail.com",
  },
  kristencamacho: {
    label: "Kristen Camacho",
    value: "kristtmc@gmail.com",
  },
  liveinlove: {
    label: "Rudy Charles",
    value: "liveinloveevents@gmail.com",
  },
  markcorreia: {
    label: "Mark Correia",
    value: "mark.correia@gmail.com",
  },
  mixednutz: {
    label: "Craig Gun-Munro",
    value: "c.gun-munro@mixnutz.bb",
  },
  royale: {
    label: "Don Bideshi",
    value: "carnival@royale-tt.com",
  },
  winerboy: {
    label: "Arvinder Rampersad",
    value: "arvinderrampersad@gmail.com",
  },
  mvp: {
    label: "Angelique Jackson",
    value: "angeliquejackson7@gmail.com",
  },
};

export function getMarketingEmail(
  key: string
): { label: string; value: string } | null {
  const lowerKey = key.toLowerCase().trim();
  return emailMap[lowerKey] || null;
}
